import { getText } from '../internal/TextLabels'

export const Authorities = {
  PAY_APPLY: 'PAY_APPLY',
  PAY_APPLY_SKIP_SIGNING: 'PAY_APPLY_SKIP_SIGNING',
  TRANSACTIONS: 'TRANSACTIONS',
  TRANSACTIONS_DEBIT: 'TRANSACTIONS_DEBIT',
  TRANSACTIONS_CREDIT: 'TRANSACTIONS_CREDIT',
  TRANSACTIONS_ANNUL: 'TRANSACTIONS_ANNUL',
  STATISTICS: 'STATISTICS',
  MESSAGING: 'MESSAGING',
  ACCOUNTING: 'ACCOUNTING',
  SUPPORT: 'SUPPORT',
  SETTINGS: 'SETTINGS',
  USER_ADMINISTRATION: 'USER_ADMINISTRATION',
  CHANGE_USER_PROPERTIES: 'CHANGE_USER_PROPERTIES',
  SET_STORE: 'SET_STORE',
  SET_PASSWORD: 'SET_PASSWORD',
  NEWS_AUTHOR: 'NEWS_AUTHOR',
  TEMPORARY_USER: 'TEMPORARY_USER',
}

export class AuthorityLabels {
  constructor() {
    this.labels = {}
    this.labels[Authorities.PAY_APPLY] = getText('user.authorities.payApply')
    this.labels[Authorities.TRANSACTIONS] = getText(
      'user.authorities.transactions',
    )
    this.labels[Authorities.TRANSACTIONS_DEBIT] = getText(
      'user.authorities.transactionsDebit',
    )
    this.labels[Authorities.TRANSACTIONS_CREDIT] = getText(
      'user.authorities.transactionsCredit',
    )
    this.labels[Authorities.TRANSACTIONS_ANNUL] = getText(
      'user.authorities.transactionsAnnul',
    )
    this.labels[Authorities.STATISTICS] = getText('user.authorities.stats')
    this.labels[Authorities.MESSAGING] = getText('user.authorities.messages')
    this.labels[Authorities.ACCOUNTING] = getText('user.authorities.accounting')
    this.labels[Authorities.SUPPORT] = getText('user.authorities.support')
    this.labels[Authorities.SETTINGS] = getText('user.authorities.settings')
    this.labels[Authorities.USER_ADMINISTRATION] = getText(
      'user.authorities.userAdmin',
    )
  }
}
